import { Link } from "wouter";
import { getFeaturedPosts } from "@/data/blogPosts";
import { Calendar, Clock, ChevronRight } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export default function FeaturedBlogPosts() {
  const featuredPosts = getFeaturedPosts().slice(0, 3);

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[#333333] mb-4">
            Latest Travel Insights
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Discover Turkey through our expert guides, insider tips, and cultural insights
            to make your Turkish adventure unforgettable.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {featuredPosts.map(post => (
            <Card key={post.id} className="hover:shadow-xl transition-shadow duration-300 border-0 shadow-md">
              <CardHeader className="pb-3">
                <div className="flex items-center gap-2 text-sm text-gray-500 mb-2">
                  <Calendar className="h-4 w-4" />
                  <span>{new Date(post.date).toLocaleDateString()}</span>
                  <Clock className="h-4 w-4 ml-2" />
                  <span>{post.readTime}</span>
                </div>
                <CardTitle className="hover:text-[#E30A17] transition-colors duration-200 leading-tight">
                  <Link href={`/blog/${post.slug}`}>
                    {post.title}
                  </Link>
                </CardTitle>
                <CardDescription className="line-clamp-3">
                  {post.excerpt}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <div className="flex flex-wrap gap-2 mb-4">
                  {post.tags.slice(0, 2).map(tag => (
                    <Badge 
                      key={tag} 
                      variant="secondary"
                      className="text-xs"
                    >
                      {tag}
                    </Badge>
                  ))}
                </div>
                <Link 
                  href={`/blog/${post.slug}`}
                  className="inline-flex items-center text-[#E30A17] hover:text-[#B8070F] font-medium transition-colors duration-200"
                >
                  Read More <ChevronRight className="h-4 w-4 ml-1" />
                </Link>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center">
          <Link 
            href="/blog"
            className="inline-flex items-center bg-[#E30A17] text-white px-8 py-3 rounded-lg font-semibold hover:bg-[#B8070F] transition-colors duration-200 shadow-lg hover:shadow-xl"
          >
            View All Blog Posts
            <ChevronRight className="h-5 w-5 ml-2" />
          </Link>
        </div>
      </div>
    </section>
  );
} 